// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatInfo__container-b7dbc7 {
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 8px;
  border-radius: 16px;
  cursor: pointer;
}

.ChatInfo__container-b7dbc7:hover {
  background-color: var(--base-10);
}

.ChatInfo__container-b7dbc7.ChatInfo__active-a63209 {
  background-color: var(--base-20);
}

.ChatInfo__info-f610b8 {
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 8px;
  border-radius: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/ChatInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  padding: 8px;\n  border-radius: 16px;\n  cursor: pointer;\n}\n\n.container:hover {\n  background-color: var(--base-10);\n}\n\n.container.active {\n  background-color: var(--base-20);\n}\n\n.info {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  padding: 8px;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatInfo__container-b7dbc7`,
	"active": `ChatInfo__active-a63209`,
	"info": `ChatInfo__info-f610b8`
};
module.exports = ___CSS_LOADER_EXPORT___;
